import styles from './styles.module.scss';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { Board } from '../../../../../components/Board';
import { useNavigate } from 'react-router-dom';
import { verifyRoutePermissions } from '../../../../../globalFunctions';
import { NavButton } from '../../../../../components/NavButton';
import CardEvento from './cardEvento';
export const LogicManagerEventsRoute = () => {
    const [eventos, setEventos] = useState<any>([]);
    const [titulo, setTitulo] = useState<string>(""); // Inicialize como null
    const [descricao, setDescricao] = useState<string>(""); // Inicialize como null

    const navigate = useNavigate()
    const [user,setUserAuth] = useState<any>(null)
    useEffect(() => {
        fetchEventos();
    }, []);



    const fetchEventos = async () => {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/evento`);
        setEventos(response.data);
       console.log(response.data)
    };
    

    useEffect(() => {
        const user = verifyRoutePermissions(
            ['auth', 'email.verified', 'not.pending.update', 'logicmanager.admin'],
            navigate
        );

        if (typeof user === 'object') {
            setUserAuth(user);
        }
    }, []);

    const sendFormEvento  =async (formData) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/evento`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            setTitulo('');
            setDescricao('');
            fetchEventos()
        } catch (error: any) {
            if (error.response && error.response.status === 422) {
                alert('Erro de validação: ' + JSON.stringify(error.response.data.errors));
            } else {
                alert('Erro ao adicionar membro: ' + error.message);
            }
        }
    }

    


    const adicionarEvento = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('titulo', titulo);
        formData.append('desc', descricao);
        sendFormEvento(formData)
    
       
    };

    const deletarEvento = async (id) => {
        await console.log(axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/evento/${id}`));
        fetchEventos()
    };

    const goBackwards = () => {     
        navigate('/manager');       
};

    return (

<div className={styles.wrapper}>
<Board wrapperClass={styles.board}>

        <div className={styles.container}>    
            <h1 className={styles.titulo}>Evento</h1>
            <form onSubmit={adicionarEvento} className="form">
            <input
                    type="text"
                    placeholder="Titulo"
                    value={titulo}
                    onChange={(e) => setTitulo(e.target.value)}
                    required
                />
                <input
                    type="text"
                    placeholder="Descrição"
                    value={descricao}
                    onChange={(e) => setDescricao(e.target.value)}
                    required
                />
                <button type="submit" style={{ backgroundColor: 'green', color: 'white' }}>Adicionar Evento</button>
                </form>
                <div className={styles.lista}>
                {eventos.map((evento) => (
                    <CardEvento  evento={evento} deletarEvento={deletarEvento}/>
                ))}
            </div>
        </div>
                    </Board>
                    <NavButton
                            direction='left'
                            style={{ left: '0.4vw', top: '2vw', zIndex: '20' }}
                            onClick={goBackwards}
                            /> 
                    </div>
    );
};

